import React from 'react'
import { connectRange } from 'react-instantsearch-dom'
import { useTranslation } from 'react-i18next'
import Slider  from 'rc-slider';
import 'rc-slider/assets/index.css'
import './RangeSlider.scss';

interface RangeSliderProps {
  min: number;
  max: number;
  currentRefinement: { min: number; max: number };
  canRefine: boolean;
  refine: (value: { min: number; max: number }) => void;
  idCustom?: string;
  title?: string;
}


const RangeSlider: React.FC<RangeSliderProps> = ({
  min,
  max,
  currentRefinement,
  canRefine,
  refine,
  // idCustom,
  title,
}) => {
  const [stateMin, setStateMin] = React.useState(min)
  const [stateMax, setStateMax] = React.useState(max)
  const { t } = useTranslation()

  React.useEffect(() => {
    if (canRefine) {
      setStateMin(currentRefinement.min)
      setStateMax(currentRefinement.max)
    } else {
    }
  }, [currentRefinement.min, currentRefinement.max])
  if (min === max) {
    return null
  }

  const handleChangeComplete = (value: number | number[]) => {
    const [newMin, newMax] = value as number[]
    if (currentRefinement.min !== newMin || currentRefinement.max !== newMax) {
      refine({ min: newMin, max: newMax })
    }
  }

 
  const handleChange = (value: number | number[]) => {
    const [newMin, newMax] = value as number[]
    setStateMin(newMin)
    setStateMax(newMax)
  }

  return (
    <div>
      <div className='range'>
        <span>{t('SAR') + ' ' + stateMin + ' - '}</span>
        <span>{t('SAR') + ' ' + stateMax}</span>
      </div>
      <div id={title}>
           <Slider
          range
          min={min}
          max={max}
          value={[stateMin, stateMax]}
          onChange={handleChange}
          onAfterChange={handleChangeComplete} 
        />

      </div>
    </div>
  )
}

const CustomRangeSlider = connectRange(RangeSlider)
export default CustomRangeSlider
